import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ReactElement } from "react";
import {
  Book,
  BookOpen,
  ChevronLeft,
  ChevronRight,
  File,
  HandCoins,
  House,
  LogOut,
  MonitorStop,
  Presentation,
  Settings2,
  Vote,
  Lock,
} from "lucide-react";
import { useUser } from "Context/userContext";
import { useEnroll } from "Context/enrollContext";

import {
  // PaidInternship,
  // Quiz,
  Lms_V1_test,
  ResumeV1,
  ChallengeV1,
  AiEvaluationV1,
  // AiEvaluationV2,
  InternshipsV1,
  InternshipsV2,
  InternshipsV3,
  Notes,
} from "Pages/index";
import { useAuth } from "Context/authContext";
import TruncatedText from "Components/Truncate";

interface menuArr {
  title?: string; // Title of the menu item
  id?: string; // Unique identifier for the menu item
  element?: ReactElement; // React element to render for this menu item
  status?: string; // Status or additional metadata for the menu item
  subMenu?: Array<Course>; // Nested submenu items
  icon?: string;
}
interface Course {
  _id: string;
  type: string;
  title: string;
  description: string;
  trainer: string;
  totalLessons: number;
  completionPercentage?: number;
  planType: string;
  startDate: string;
  step: string;
  active: boolean;
  desktopImg: string;
  mobileImg: string;
  isCertificateAvailable: boolean;
  isPaidInternshipAvailable: boolean;
  groupLink?: string;
  menu?: Array<string>;
}
interface Sidebar {
  menuArr: Array<menuArr>;
  currentMenu: string | undefined;
  setCurrentMenu: any;
  isMenuActive: boolean;
  setIsMenuActive: any;
  isMobile: boolean;
  isSubMenuOpen: boolean;
  setIsSubMenuOpen: any;
  isSidebarOpen: any;
  setIsSideBarOpen: any;
  getSectionStatus?: any;
}

const menuArrayFooter: menuArr[] = [
  // { title: 'Help & information', id: 'help', icon: "HelpIcon", },
  { title: "Log Out", id: "logout", icon: "LogoutIcon" },
];

interface MenuItem {
  title?: string; // Title of the menu item
  id?: string; // Unique identifier for the menu item
  element?: ReactElement; // React element to render for this menu item
  status?: string; // Status or additional metadata for the menu item
  subMenu?: Array<any>; // Nested submenu items
  icon?: string;
}

export default function Sidebar({
  getSectionStatus,
  isSidebarOpen,
  setIsSideBarOpen,
  setIsSubMenuOpen,
  isSubMenuOpen,
  menuArr,
  currentMenu,
  setCurrentMenu,
  isMenuActive,
  setIsMenuActive,
  isMobile,
}: Sidebar) {
  const navigate = useNavigate();
  const { user } = useUser();
  const { enroll, updateEnroll } = useEnroll();
  const { logout } = useAuth();

  const continueWithLMS = (data: Course) => {
    updateEnroll({
      ...enroll,
      _id: data._id,
      active: data.active,
      isCertificateAvailable: data.isCertificateAvailable,
      planType: data.planType,
      step: data.step,
      type: data.type,
      title: data.title,
      groupLink: data.groupLink,
      startDate: data.startDate,
      menu: data.menu,
      isPaidInternshipAvailable: data.isPaidInternshipAvailable,
      updatedAt: new Date().toISOString(),
    });
  };
  const isCourseDashboard = window.location.pathname.includes("program");
  // const [isSidebarOpen, setIsSideBarOpen] = useState<any>(false)
  // const { isMobile } = useView()

  const programMenuArr: MenuItem[] = useMemo(() => {
    const finalMenu = enroll.menu
      ?.map((item) => {
        const status = getSectionStatus(item.toLowerCase(), enroll.step);
        switch (item) {
          case "RESUME":
            // return { title: 'My Resume', id: 'resume', element: <Resume />, status: 'UNLOCKED' , icon: "HomeIcon",};
            return {
              title: "My Resume",
              id: "resume",
              element: <ResumeV1 />,
              status: "UNLOCKED",
              icon: "ResumeIcon",
            };
          case "CHALLENGE":
            // return { title: 'My Challenge', id: 'assessment', element: <Challenge />, status, icon: "HomeIcon", };
            return {
              title: "My Challenge",
              id: "assessment",
              element: <ChallengeV1 />,
              status,
              icon: "ChallengeIcon",
            };
          // case 'QUIZ':
          //   return { title: 'My Quiz', id: 'quiz', element: <Quiz />, status: 'UNLOCKED', icon: "QuizIcon", };
          case "INTERNSHIP":
            return {
              title: "My Internship",
              id: "internship",
              element: <InternshipsV1 />,
              status,
              icon: "InternshipIcon",
            };
          case "INTERNSHIPV1":
            return {
              title: "My Internship",
              id: "internship",
              element: <InternshipsV2 />,
              status,
              icon: "InternshipIcon",
            };
          case "INTERNSHIPV3":
            return {
              title: "My Internship",
              id: "internship",
              element: <InternshipsV3 />,
              status,
              icon: "InternshipIcon",
            };
          case "INTERVIEW":
            return {
              title: "My Interview",
              id: "interview",
              element: <AiEvaluationV1 />,
              status,
              icon: "AiInterview",
            };
          case "LMS_HYBRID":
          case "LMS_LIVE":
            // return { title: 'My Learning (LMS)', id: 'learning', element: item === 'LMS_HYBRID' ? <v1_Lms/> : <Lms_V1 />, status: 'UNLOCKED', icon: "HomeIcon", };
            return {
              title: "My Learning (LMS)",
              id: "learning",
              element:
                item === "LMS_HYBRID" ? <Lms_V1_test /> : <Lms_V1_test />,
              status: "UNLOCKED",
              icon: "LmsIcon",
            };
          case "INTERNSHIP_PAID":
          // return enroll.isPaidInternshipAvailable
          //   ? { title: 'Paid Internship', id: 'alpha', element: <PaidInternship />, status }
          //   : null;
          default:
            return null;
        }
      })
      .filter((item) => item !== null) as MenuItem[];

    if (enroll.title) {
      finalMenu?.unshift({ title: enroll.title, id: "title", status: "NONE" });
    }

    if (enroll.planType !== "DI")
      finalMenu?.push({
        title: "Notes",
        id: "notes",
        element: <Notes />,
        status: "NOTES",
        icon: "NotesIcon",
      });

    return finalMenu;
  }, [
    isCourseDashboard,
    enroll.menu,
    user.paymentStatus,
    enroll.title,
    enroll.step,
    enroll.courses,
  ]);

  return (
    // <div className={`bg-[#eae6e4] absolute transition-all z-50 duration-500 ease-in-out md:relative tailwingSidebar phone:h-full pt-8 ${isMenuActive? 'w-4/5 md:w-72' : 'w-0'}`} id="sidebar-desktop">
    <div
      className={`flex flex-col overflow-hidden justify-between border-r-1 border-[#e2e2e2] bg-white h-[100dvh] top-0 transition-all duration-[800ms] ease-in-out z-[9990]
      
    ${
      isMobile
        ? isMenuActive
          ? "w-4/5 md:w-80 absolute"
          : "w-0 absolute"
        : "w-80 relative"
    }`}
      id="sidebar-desktop"
    >
      {/* <div className={`absolute hidden md:block top-1/2 right-[-35px] z-50 ${isMenuActive ? "" : "transform rotate-540"} `} onClick={() => setIsMenuActive(!isMenuActive)}><MyImage src={Image.Sidebar_Toogle} className={` ${isMenuActive ? "" : "transform transition-all rotate-180"} `} loadOnPageLoad={true} /> </div> */}
      {isMenuActive && (
        <div className="md:hidden absolute right-0 p-2">
          <span className="cursor-pointer">
            <img
              onClick={() => {
                setIsMenuActive(!isMenuActive);
                setIsSubMenuOpen(false);
              }}
              width="25"
              height="25"
              className="block md:hidden"
              src={`https://img.icons8.com/ios-filled/64/multiply.png`}
              alt="menu--v6"
            />
          </span>
        </div>
      )}
      {/* overflow */}
      <ul className="list-none  w-max p-4">
        <div className="md:w-48 mb-14  h-20  p-3">
          <span className="cursor-pointer">
            <img
              onClick={() => navigate("/")}
              id="logoimgHeader"
              className="w-auto h-full md:block overflow-hidden"
              src="https://i.ibb.co/FxHVzmm/Logo.png"
              alt={"logo"}
            />
          </span>
        </div>
        {
          !isSidebarOpen
            ? menuArr.map((element, index) => {
                return (
                  <li
                    // className={`${element.id === currentMenu ? "text-gray-900 bg-gray-100 rounded-lg" : "text-gray-500"}`}
                    key={index}
                  >
                    <div
                      className={`cursor-pointer font-semibold text-sm phone:text-base mb-2 mt-2  p-4 py-[9px] flex gap-2 items-center`}
                      onClick={() => {
                        // if (isMobile) setIsMenuActive(false)
                        navigate(`/v1/user/dashboard/${element.id}`);
                        // if (element && element?.subMenu && element.subMenu.length > 0)
                        //   setIsSideBarOpen(element.subMenu)
                      }}
                    >
                      {element.icon === "HomeIcon" && (
                        <House
                          strokeWidth={1.5}
                          className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  ${
                            element.id === currentMenu && "text-brand"
                          }`}
                        />
                      )}
                      {element.icon === "ResumeIcon" && (
                        <File
                          strokeWidth={1.5}
                          className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${
                            element.id === currentMenu && "text-brand"
                          }`}
                        />
                      )}
                      {element.icon === "ReferAndEarnIcon" && (
                        <HandCoins
                          strokeWidth={1.5}
                          className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${
                            element.id === currentMenu && "text-brand"
                          }`}
                        />
                      )}
                      {element.icon === "SettingsIcon" && (
                        <Settings2
                          strokeWidth={1.5}
                          className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  ${
                            element.id === currentMenu && "text-brand"
                          }`}
                        />
                      )}
                      {element.icon === "NotesIcon" && (
                        <Book
                          strokeWidth={1.5}
                          className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${
                            element.id === currentMenu && "text-brand"
                          }`}
                        />
                      )}

                      <span
                        className="item text-sm"
                        style={{ color: element.id === "alpha" ? "" : "" }}
                      >
                        {element.title}
                      </span>
                    </div>
                    {/* Submenu */}
                    {element.subMenu && (
                      <ul className="ml-4 pl-4">
                        {element.subMenu.map((subItem, subIndex) => {
                          return (
                            <li
                              key={subIndex}
                              className="text-gray-500 hover:text-gray-700"
                            >
                              <button
                                className="text-sm py-2 px-4 flex items-center gap-2 justify-between w-full"
                                onClick={() => {
                                  console.log("subMenu-", subItem);
                                  if (
                                    ["HYBRID"].includes(subItem.planType) &&
                                    new Date().getTime() <
                                      new Date(
                                        subItem.startDate || ""
                                      ).getTime()
                                  )
                                    return;
                                  // if(["DI","COMBO"].includes(subItem.planType)) return
                                  setIsSubMenuOpen(true);
                                  continueWithLMS(subItem);
                                }}
                              >
                                <span>
                                  <TruncatedText
                                    maxLength={17}
                                    text={subItem.title}
                                  />
                                </span>
                                {(["HYBRID", "RECORDED"].includes(
                                  subItem.planType
                                ) &&
                                  new Date().getTime() >
                                    new Date(
                                      subItem.startDate || ""
                                    ).getTime()) ||
                                ["DI", "COMBO"].includes(subItem.planType) ? (
                                  <ChevronRight
                                    strokeWidth={1.5}
                                    className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  rounded-full ${
                                      element.id === currentMenu && "text-brand"
                                    }`}
                                  />
                                ) : (
                                  <Lock
                                    strokeWidth={1.5}
                                    className={`w-6 h-6 md:w-6 md:h-6 p-1 hover:bg-gray-200   ${
                                      element.id === currentMenu && "text-brand"
                                    }`}
                                  />
                                )}
                              </button>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })
            : ""
          // isSidebarOpen.map((element: any, index: any) => {
          //   return (
          //     <li className={`cursor-pointer ${element.id === currentMenu ? "bg-[#471770] rounded-sm sidebar_active text-white" : "text-black"}`} key={index}>
          //       <button className=' font-semibold text-sm phone:text-base w-max mb-2 mt-2  p-4 flex gap-2 items-center' onClick={() => {
          //         if (element.id === "backsub")
          //           setIsSideBarOpen(false)
          //       }}>
          //         <span className="item" style={{ color: element.id === "alpha" ? "" : "" }}>{element.title}</span>
          //         {element.subMenu && element?.subMenu.length > 0 && <MyImage src={Image.Sidebar_Toogle} className={` w-4 h-4`} loadOnPageLoad={true} />}

          //       </button>

          //     </li>
          //   )
          // })
        }
      </ul>
      {/* <ul className='list-none overflow-hidden p-4'>
          <li >
            <div className="bg-[#fafafa] rounded-3xl p-4 m-4 max-w-[240px] hover:shadow-xl transition-shadow duration-300">
              <div className="space-y-4 text-center">
                <h4 className="font-bold text-gray-900">
                  Explore More Programs
                </h4>

                <p className="text-gray-500 text-sm">
                  Get 1 month free<br />and unlock
                </p>

                <button
                  // onClick={onUpgrade}
                  className="w-full py-1.5 px-2 bg-blue-100 rounded-full font-medium hover:bg-blue-200 transition-colors duration-200"
                >
                  Upgrade
                </button>
              </div>
            </div>
          </li>
        </ul> */}
      <ul className="list-none overflow-hidden  p-4">
        {menuArrayFooter.map((element, index) => {
          return (
            // <li className={`${element.id === currentMenu ? "bg-[#471770] rounded-sm sidebar_active text-white" : "text-black"}`} key={index}>
            <li
              className={`cursor-pointer ${
                element.id === currentMenu ? "text-gray-900" : "text-red-500"
              }`}
              key={index}
            >
              <button
                className=" font-semibold text-sm phone:text-sm w-max mb-2 mt-2  p-4 flex gap-2 items-center"
                onClick={() => {
                  // if (isMobile) setIsMenuActive(false)
                  // navigate(`/user/dashboard/${element.id}`)
                  if (element && element?.subMenu && element.subMenu.length > 0)
                    setIsSideBarOpen(element.subMenu);
                  if (element.id == "logout") {
                    localStorage.removeItem("user");
                    localStorage.removeItem("cohort");
                    updateEnroll({ _id: "" });
                    localStorage.clear();
                    sessionStorage.clear();
                    logout();
                  }
                }}
              >
                {element.icon === "LogoutIcon" && (
                  <LogOut
                    strokeWidth={1.5}
                    className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  rounded-full ${
                      element.id === currentMenu && "text-brand"
                    }`}
                  />
                )}
                <span
                  className="item"
                  style={{ color: element.id === "alpha" ? "" : "" }}
                >
                  {element.title}
                </span>
                {/* {element.subMenu && element?.subMenu.length > 0 && <MyImage src={Image.Sidebar_Toogle} className={` w-4 h-4 rotate-[540deg]`} loadOnPageLoad={true} />} */}
                {/* {element.subMenu && element?.subMenu.length > 0 && <MyImage src={Image.PlusIcon} className={` w-6 h-6`} loadOnPageLoad={true} />} */}
              </button>
            </li>
          );
        })}
      </ul>

      {/* {isSubMenuOpen && ( */}
      <div
        className={`flex flex-col overflow-hidden transition-all duration-[800ms] ease-in-out right-0 border-r-1 border-[#e2e2e2] bg-white h-[100vh] transform  z-[99999] ${
          isSubMenuOpen ? "w-full absolute" : "w-0 absolute"
        }`}
        id="sidebar-desktop"
      >
        <div className="text-gray-900 bg-gray-100 rounded-lg">
          <button
            onClick={() => setIsSubMenuOpen(false)}
            className="font-semibold text-sm phone:text-base w-max p-4 py-[20px] flex gap-2 items-center"
          >
            <ChevronLeft
              strokeWidth={1.5}
              className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200`}
            />
            <span className="item">Back to dashboard</span>
          </button>
        </div>
        <ul className="list-none overflow-hidden px-4">
          {programMenuArr?.map((element, index) => {
            console.log(element);

            return (
              <li
                className={`cursor-pointer ${
                  element.id === currentMenu
                    ? "text-gray-900 bg-gray-100 rounded-lg"
                    : "text-gray-500"
                }`}
                key={index}
              >
                <button
                  className="font-semibold text-sm phone:text-base w-max mb-2 mt-2  p-4 py-[9px] flex gap-2 items-center"
                  onClick={() => {
                    if (isMobile) setIsMenuActive(false);
                    if (element.id === "title") {
                      return;
                    } else if (element.id === "dashboard")
                      navigate(`/v1/user/dashboard/course`);
                    else {
                      setIsSubMenuOpen(false);
                      navigate(`/v1/program/dashboard/${element.id}`);
                    }
                  }}
                >
                  {element.icon === "LmsIcon" && (
                    <MonitorStop
                      strokeWidth={1.5}
                      className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${
                        element.id === currentMenu && "text-brand"
                      }`}
                    />
                  )}
                  {element.icon === "ResumeIcon" && (
                    <File
                      strokeWidth={1.5}
                      className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${
                        element.id === currentMenu && "text-brand"
                      }`}
                    />
                  )}
                  {element.icon === "ChallengeIcon" && (
                    <BookOpen
                      strokeWidth={1.5}
                      className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${
                        element.id === currentMenu && "text-brand"
                      }`}
                    />
                  )}
                  {element.icon === "InternshipIcon" && (
                    <Vote
                      strokeWidth={1.5}
                      className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  ${
                        element.id === currentMenu && "text-brand"
                      }`}
                    />
                  )}
                  {element.icon === "AiInterview" && (
                    <Presentation
                      strokeWidth={1.5}
                      className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${
                        element.id === currentMenu && "text-brand"
                      }`}
                    />
                  )}
                  {element.icon === "NotesIcon" && (
                    <Book
                      strokeWidth={1.5}
                      className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${
                        element.id === currentMenu && "text-brand"
                      }`}
                    />
                  )}

                  <span
                    className={`item  ${
                      element.id === "title"
                        ? "font-semibold text-lg"
                        : "text-sm"
                    }`}
                    style={{ color: element.id === "title" ? "#971eff" : "" }}
                  >
                    {element.id === "quiz" ? (
                      <>
                        <TruncatedText
                          maxLength={20}
                          text={element.title || ""}
                        />
                      </>
                    ) : (
                      <TruncatedText
                        maxLength={22}
                        text={element.title || ""}
                      />
                    )}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
      {/* )} */}
    </div>
  );
}
